module.exports = __webpack_public_path__ + "img/2_67.739cb902.png";